import "./SingleProjectTemplate.module.css"
import Header from "@/reusable_sections/Header"
import ProjectDetail from "./sections/ProjectDetail"
import Footer from "@/reusable_sections/Footer"

export default function SingleProjectTemplatePage() {

  return (
    <div>
      <Header />
      <ProjectDetail />
      <Footer />
    </div>
  )
}
